// extracted by mini-css-extract-plugin
export default {"paragraph":"ThirdStep_paragraph__crIE4"};